var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('BackOnTop'),_c('PageTitleBar',{attrs:{"title":"新密碼已發送至您的手機，請至登入頁面輸入新密碼後登入"}}),_c('v-container',{staticClass:"fp-container px-4 mb-4",attrs:{"fluid":""}},[_c('BtnNext',{staticClass:"btn",on:{"click":_vm.handleNext}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }